import React from 'react';
import teoria from "teoria";
import PropTypes from 'prop-types';

import SongStore from '../stores/SongStore';

import SongSaveAction from '../actions/SongSaveAction';
import SongPlayAction from '../actions/SongPlayAction';
import SongStopAction from '../actions/SongStopAction';

import ToggleMidiMapMode from '../actions/ToggleMidiMapMode';
import SongetNameAction from '../actions/SongetNameAction';
import SongChangeKey from '../actions/SongChangeKey';
import SongChangeTonic from '../actions/SongChangeTonic';
import SongTempoChange from '../actions/SongTempoChange';
import SongLoadAction from "../actions/SongLoadAction";
import NewSongAction from "../actions/NewSongAction";

export default class TopMenu extends React.Component {
    static propTypes = {
        name: PropTypes.string
    };

    static contextTypes = {
        executeAction: PropTypes.func.isRequired,
        getStore: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        var songStore = this.context.getStore(SongStore);
        this.setState({
            tonic: songStore.song.tonic,
            key: songStore.song.key,
            name: songStore.song.name,
            tempo: songStore.song.getTempo(),
            playing: songStore.playing
        });
    }

    componentDidMount() {
        var songStore = this.context.getStore(SongStore);

        songStore.on("TOPMENU_UPDATE", () => {
            this.setState({
                tonic: songStore.song.tonic,
                key: songStore.song.key,
                name: songStore.song.name,
                tempo: songStore.song.getTempo(),
                playing: songStore.playing
            });
        });

        songStore.on('MIDI_MAP_MODE_CHANGE', (isEnabled) => {
            this.setState({
                mapMode: isEnabled
            });
        });
    }

    handleSaveClick(event) {
        event.preventDefault();
        this.context.executeAction(SongSaveAction);
    }

    handlePlayClick(event) {
        event.preventDefault();
        this.context.executeAction(SongPlayAction);
    }

    handleStopClick(event) {
        event.preventDefault();
        this.context.executeAction(SongStopAction);
    }

    handleChangeTonic(event) {
        event.preventDefault();
        this.context.executeAction(SongChangeTonic, {tonic: event.target.value});
    }

    handleChangeKey(event) {
        event.preventDefault();
        this.context.executeAction(SongChangeKey, {key: event.target.value});
    }

    handleNewSong(event) {
        event.preventDefault();
        this.context.executeAction(NewSongAction);
    }

    handleLoadSong(event) {

        event.preventDefault();

        const input = event.target;

        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = (e) => {
                this.context.executeAction(SongLoadAction, { songData: JSON.parse(e.target.result) });
            };
            reader.readAsText(input.files[0]);
        }

    }


    handleMidiMap(event) {
        event.preventDefault();
        this.context.executeAction(ToggleMidiMapMode);
    }

    handleNameChange(event) {
        this.context.executeAction(SongetNameAction, {
            name: event.target.value
        });
    }

    handleTempoChange(event) {
        this.context.executeAction(SongTempoChange, {
            tempo: event.target.value
        });
    }

    render() {

        var tonics = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
        var keys = teoria.Scale.KNOWN_SCALES;

        return (
            <div className="TopMenu">
                <p className="file-actions">
                    <button className="btn" onClick={this.handleNewSong.bind(this)}>New</button>
                    <button className="btn" onClick={this.handleSaveClick.bind(this)}>Save</button>
                    <label className="btn">
                        Load
                        <input type="file" style={{display: "none"}} onChange={this.handleLoadSong.bind(this)} value=""/>
                    </label>

                </p>
                <p className="song-actions">
                    <button className={this.state.playing ? "playing btn" : "btn"}
                            onClick={this.handlePlayClick.bind(this)}><i className="material-icons">play_arrow</i>
                    </button>
                    <button className="btn" onClick={this.handleStopClick.bind(this)}><i
                        className="material-icons">stop</i></button>

                    <select onChange={this.handleChangeTonic.bind(this)} value={this.state.tonic}>
                        {tonics.map((tonic) => {
                            return <option key={tonic} value={tonic}>{tonic}</option>;
                        })}
                    </select>

                    <select onChange={this.handleChangeKey.bind(this)} value={this.state.key}>
                        {keys.map((key) => {
                            return <option value={key}
                                           key={key}>{key.substr(0, 1).toUpperCase() + key.substr(1)}</option>;
                        })}
                    </select>

                    <input className="tempo-input" type="number" value={this.state.tempo}
                           onChange={this.handleTempoChange.bind(this)}/>

                    <input className="name-input" type="text" value={this.state.name}
                           onChange={this.handleNameChange.bind(this)} placeholder="Name your song"/>

                    <button className={(this.state.mapMode ? "active " : "") + "btn midi-btn"}
                            onClick={this.handleMidiMap.bind(this)}>MIDI MAP
                    </button>

                </p>
            </div>
        );
    }
}
